import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getStorage } from '@minerva-analytics/pantheon';
import google from 'assets/google.png';
import event from 'utils/event';

import {
  FacebookLoginButton,
  GoogleLoginButton,
  GoogleImage,
  GoogleImageWrapper,
  FacebookImage,
  ButtonText,
  ToggleFacebookLink,
} from './LoginButtons.styles';

export class LoginButtons extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showFacebookButtonToggled: false,
    };
  }

  onToggleHideFacebook = () => {
    const { showFacebookButtonToggled } = this.state;

    event(`togle-hide-facebook`, [`click`, `toggle-hide-facebook`, showFacebookButtonToggled ? `hide` : `show`]);
    this.setState({ showFacebookButtonToggled: !showFacebookButtonToggled });
  }

  render() {
    const { facebookLogin, gmailLogin, hideFacebookButtonParam, small } = this.props;
    const { showFacebookButtonToggled } = this.state;

    const hideFacebook = !showFacebookButtonToggled && ((hideFacebookButtonParam && hideFacebookButtonParam === `t`)
      || (__CLIENT__ && getStorage({ key: `g_button`, session: true, forceCookies: true })) === `t`);

    return (
      <React.Fragment>
        <GoogleLoginButton onClick={ gmailLogin } small={small}>
          <GoogleImageWrapper small={small}>
            <GoogleImage src={ google } alt="This should say G. for Google" small={small} />
          </GoogleImageWrapper>
          <ButtonText small={small}>Sign in with Google</ButtonText>
        </GoogleLoginButton>
        {
          !hideFacebook
            ? <FacebookLoginButton onClick={facebookLogin} small={small}>
              <FacebookImage small={String(small)} />
              <ButtonText small={small}>Sign in with Facebook</ButtonText>
            </FacebookLoginButton>
            : <ToggleFacebookLink onClick={this.onToggleHideFacebook}>
              Or sign up with Facebook instead!
            </ToggleFacebookLink>
        }
      </React.Fragment>
    );
  }
}

LoginButtons.propTypes = {
  facebookLogin: PropTypes.func.isRequired,
  gmailLogin: PropTypes.func.isRequired,
  hideFacebookButtonParam: PropTypes.string,
  small: PropTypes.bool,
};

export default connect((state) => {
  return {
    hideFacebookButtonParam: state.extra.params.g_button,
  };
})(LoginButtons);
